import type { GlassMap } from "./liquidGlassOptics";
import { glassRefractionScale } from "./liquidGlassOptics";

export function LiquidGlassFilter({
  adaptive,
  id,
  map,
}: { adaptive: boolean; id: string; map: GlassMap }) {
  return (
    <svg aria-hidden="true" className="ark-liquid-filter" focusable="false" data-glass-decoration="">
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height={map.height}
          id={id}
          width={map.width}
          x="0"
          y="0"
        >
          <feImage height={map.height} href={map.source} result="rim" width={map.width} x="0" y="0" />
          <feComponentTransfer in="rim" result="normals">
            {/* Map the 8-bit neutral value (128) to exactly 0.5. */}
            <feFuncR type="linear" intercept={-0.5 / 255} />
            <feFuncG type="linear" intercept={-0.5 / 255} />
          </feComponentTransfer>
          <feDisplacementMap in="SourceGraphic" in2="normals" result="refracted" scale={glassRefractionScale} xChannelSelector="R" yChannelSelector="G" />
          {adaptive ? (
            <>
              {/* Only the tint mask is averaged. The visible backdrop stays sharp.
                  Linear RGB weights measure the compositor's actual luminance. */}
              <feGaussianBlur colorInterpolationFilters="linearRGB" in="refracted" result="backdrop-tone" stdDeviation="12" />
              <feColorMatrix colorInterpolationFilters="linearRGB" in="backdrop-tone" result="light-mask" type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  -0.08504 -0.28608 -0.02888 0 0.4" />
              <feFlood floodColor="#fff" result="light-tint" style={{ floodOpacity: "var(--ark-glass-adapt-light, 1)" }} />
              <feComposite in="light-tint" in2="light-mask" operator="in" result="light-veil" />
              <feBlend colorInterpolationFilters="linearRGB" in="light-veil" in2="refracted" mode="normal" result="light-adapted" />
              <feColorMatrix colorInterpolationFilters="linearRGB" in="backdrop-tone" result="dark-mask" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0.161576 0.543552 0.054872 0 0" />
              <feFlood floodColor="#000" result="dark-tint" style={{ floodOpacity: "var(--ark-glass-adapt-dark, 0)" }} />
              <feComposite in="dark-tint" in2="dark-mask" operator="in" result="dark-veil" />
              <feBlend colorInterpolationFilters="linearRGB" in="dark-veil" in2="light-adapted" mode="normal" result="adapted" />
            </>
          ) : null}
          <feColorMatrix in="rim" result="reflection" type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0.45 0 0" />
          <feBlend in={adaptive ? "adapted" : "refracted"} in2="reflection" mode="screen" />
        </filter>
      </defs>
    </svg>
  );
}
